import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import {
  changeFeeCode,
  searchFeeCode,
  clearDataSearchFeeCode
} from "~/store/fee/feeActions";
import Modal from "~/components/common/molecules/Modal";
import { urlImgBillCode } from "~/utils/manageResource";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const FeeSearchPageMobile = Loadable({
  loader: () => import(/* mobile */ "~/components/desktop/pages/FeeSearch"),
  loading: LoadableLoading
});
const FeeSearchPageDesktop = Loadable({
  loader: () => import(/* desktop */ "~/components/desktop/pages/FeeSearch"),
  loading: LoadableLoading
});

class FeeSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalViewImage: false
    };
  }

  methods = {
    handleGoBack: () => {
      const { history } = this.props;
      history.push("/");
    },
    toggleModalViewImage: () => {
      this.setState({
        modalViewImage: !this.state.modalViewImage
      });
    },

    handleSearchFee: () => {
      this.props.searchFeeCode();
    }
  };

  componentDidMount() {
    this.props.clearDataSearchFeeCode();
  }

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <FeeSearchPageMobile {...this.props} {...this.methods} />
        ) : (
          <FeeSearchPageDesktop {...this.props} {...this.methods} />
        )}
        <Modal
          modal={this.state.modalViewImage}
          title="Xem cách tìm mã số thanh toán"
          toggle={this.methods.toggleModalViewImage}
          children={
            urlImgBillCode ? (
              <img src={urlImgBillCode} alt="" className="img-fluid" />
            ) : (
              "Chưa có hình ảnh minh họa."
            )
          }
          centered
          className="centered"
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    fee: { hosNumber, fee, loading }
  } = state;
  return {
    device: type,
    hosNumber,
    fee,
    loading
  };
};

const FeeSearchHelmet = withTitle({
  component: FeeSearch,
  title: `${hospitalName.value} | Thanh toán viện phí nội trú`
});

export default connect(mapStateToProps, {
  changeFeeCode,
  searchFeeCode,
  clearDataSearchFeeCode
})(FeeSearchHelmet);
